<template>
  <div :style="stepContainer">
    <div class="w-full flex justify-center">
      <!-- <button class="button-step" @click="previousStep">←</button> -->
      <span class>{{ getMeasureStep + 1 }} / {{ getAreaLength }}</span>
      <!-- <button class="button-step" @click="nextStep">→</button> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MeasureSteps",
  data() {
    return {
      step: 0
    };
  },
  props: {
    projection: String
  },
  computed: {
    ...mapGetters(["getPictureHeight", "getMeasureStep", "getAreaLength"]),
    stepContainer() {
      return {
        height: "50px",
        backgroundColor: "white",
        position: "absolute",
        width: this.getPictureHeight * 0.6 + "px"
      };
    }
  },
  methods: {
    ...mapMutations(["setMeasureStep", "updateConstraints"]),
    nextStep() {
      //length
      this.step = this.getMeasureStep + 1;
      this.setStep();
    },
    previousStep() {
      this.step = this.getMeasureStep - 1;
      this.setStep();
    },
    setStep() {
      const payload = {
        step: this.step,
        projection: this.projection
      };
      this.updateConstraints(payload);
      this.setMeasureStep(payload);
    }
  }
};
</script>

<style>
/* .step-container {
  height: 50px; */
/* border-bottom: 2px solid red;
  border-left: 2px solid red; 
  border-right: 2px solid red; */
/* background-color: white;
  position: absolute; */
/* margin-left: 50px; */
/* } */
.button-step {
  background-color: aliceblue;
  height: 48px;
  width: 100px;
}
</style>
